import React from "react";
import { Page, PageContainer } from "../../components/base";
import { Logo, Text, ContentContainer } from "./components";
import { Link } from "react-router-dom";
import logoSrc from "../../assets/images/noire-logo-white.png";

export class HomePage extends React.Component {
  render() {
    return (
      <PageContainer>
        <Page>
          <ContentContainer>
            <Link to="register">
              <Logo src={logoSrc} alt="Noire logo" />
            </Link>
            <Text>
              <h1>bridging the gap</h1>
            </Text>
          </ContentContainer>
        </Page>
      </PageContainer>
    );
  }
}
